// MODULES
import React from "react";

// HELPERS
import {createClassName, getPropertiesByPrefix, parseDraftDataPropsToFieldState, delay} from "@helpers/utils";
import fulfillmentCheck from "./Notes.fulfillment";
import DefaultFields from "../../../components/DefaultFields/DefaultFields";
import * as CobHelpers from "../../../Cob.helpers";
import TextView from "../../../../../components/TextView/TextView";
import EditableField from "../../../components/EditableField/EditableField";
import CheckboxWithName from "../../../components/CheckboxWithName/CheckboxWithName";


export default class Notes extends React.PureComponent {
	static companyExclusive = false;
	static privateExclusive = false;

	static fields = _getFields();
	state = _getInitialState.call(this);

	componentDidUpdate(prevProps, prevState) {
		const {props, state} = this;
		const {id, onChange} = props;

		if (prevState.fields !== state.fields) {
			onChange(id, {...state}, fulfillmentCheck(props, state));
		}

    if (prevProps.draftData !== props.draftData) {
      if (props.draftData) {
        // get the draftData props specific to this section only
        const draftDataProps = getPropertiesByPrefix(props.draftData, ['futur_notes', 'checkbox_']);
        // parse the draftData props into state.fields
        const newFieldsState = parseDraftDataPropsToFieldState(this.state.fields, draftDataProps);

        this.setState(
          {
            fields: {
              ...newFieldsState
            }
          },
          async () => {          
              await delay(200);
              onChange(id, {...this.state}, fulfillmentCheck(this.props, this.state));
          }
        );
      }
		}
	}

	render() {
		const {props, state} = this;
		const {title} = props;

		const classes = createClassName("Cob-Fees", {
			"Cob-View": true,
			"fulfilled": state.isFulfilled,
		});

		return (
			<div className={classes}>
				<DefaultFields fields={this.constructor.fields}/>

				<div className="Cob-Fields">
					<h2>{title}</h2>
					<p style={{marginTop: "0"}}>
						<strong style={{color: "red"}}>Obs!</strong> Om du fyller i fältet "Information till
						Futur Pension" kommer din ansökan att behöva hanteras manuellt.
					</p>

					<CheckboxWithName
						label='Jag vill fylla i fältet "Information till Futur Pension"'
						name="checkbox_confirm_notes"
						value={state.fields.checkbox_confirm_notes.checked}
						checked={state.fields.checkbox_confirm_notes.checked}
						onChange={this._onCheckboxChange}
						style={{margin: "10px 0"}}
					/>

					{state.fields.checkbox_confirm_notes.checked && (
						<EditableField
							name="futur_notes"
							Component={TextView}
							label={`${600 - state.fields.futur_notes.length} tecken kvar`}
							value={state.fields.futur_notes}
							maxLength={600}
							valid={true}
							resize="vertical"
							fullWidth
							onChange={this._onFieldChange}
							onBlur={this._onFieldBlur}
							style={{maxHeight: "100px"}}
						/>
					)}

				</div>
			</div>
		);
	}

	_fieldValidator = (name, value) =>
	{
		return value.length > 0;
	};

	_onFieldChange = (name, value) =>
	{
		CobHelpers.onViewFieldChange.call(this, name, value);
	};

	_onFieldBlur = (name) =>
	{
		CobHelpers.onViewFieldBlur.call(this, name);
	};

	_onCheckboxChange = (name, checked) =>
	{
		this.setState({
			fields: {
				...this.state.fields,
				[name]: {...this.state.fields[name], checked}
			}
		});
	};
}

function _getFields() {
	return [
		"futur_notes"
	];
}

function _getInitialState() {
	if (this.props.prevState) return {...this.props.prevState};

	return {
		validFields: {},
		fields: {
			futur_notes: "",
			checkbox_confirm_notes: {
				checked: false
			}
		}
	};
}


// WEBPACK FOOTER //
// ./src/routes/Cob/views/Futur/Notes/Notes.js